import calculateCenter from "@turf/center";
import { AllGeoJSON } from "@turf/turf";
import { DivIcon, LatLng, MarkerCluster, Point } from "leaflet";
import { useEffect, useState } from "react";
import MarkerClusterGroup from "react-leaflet-cluster";

import { renderToStaticMarkup } from "react-dom/server";
import {
  AttributionControl,
  MapContainer,
  MapContainerProps,
  TileLayer,
  ZoomControl,
} from "react-leaflet";
import { IMarker } from "./app";
import { Markers } from "./marker-group";
import { defaultMakersConfig } from "./markerIcon";

const defaultCenter = new LatLng(52.377956, 4.89707);

export default function Map({
  markers,
  showOthers,
  ...props
}: { markers: IMarker[]; showOthers: boolean } & MapContainerProps) {
  const [center, setCenter] = useState<LatLng>(defaultCenter);

  useEffect(() => {
    if (markers.length > 0) {
      const geo = {
        type: "GeometryCollection",
        geometries: markers.map((marker) => ({
          type: "Point",
          coordinates: marker.coordinates,
        })),
      };

      try {
        const c = calculateCenter(geo as AllGeoJSON);
        setCenter(new LatLng(c.geometry.coordinates[0], c.geometry.coordinates[1]));
      } catch (error) {
        console.log(error);
      }
    }
  }, [markers]);

  return (
    <MapContainer
      center={center}
      zoomControl={false}
      zoom={13}
      attributionControl={false}
      scrollWheelZoom={false}
      className="w-full"
      {...props}
    >
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      <MarkerClusterGroup removeOutsideVisibleBounds={false} iconCreateFunction={createClusterIcon}>
        <Markers markers={markers} hidePopup={!showOthers} />
      </MarkerClusterGroup>
      <AttributionControl
        prefix={`<span class="embed-map-link"><a class="embed-map-link" href="https://leafletjs.com/">Leaflet</a> &#124; &copy; <a class="embed-map-link" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors</span>`}
      />
      <ZoomControl position="bottomright" />
    </MapContainer>
  );
}

function createClusterIcon(cluster: MarkerCluster) {
  return new DivIcon({
    html: renderToStaticMarkup(
      <div
        className="flex items-center justify-center bg-primary rounded-full"
        style={{
          width: defaultMakersConfig.iconWidth,
          height: defaultMakersConfig.iconHeight,
        }}
      >
        <span className="text-white font-bold font-quicksand">{cluster.getChildCount()}</span>
      </div>
    ),
    iconSize: new Point(42, 42),
    iconAnchor: [21, 21],
    tooltipAnchor: [84, 42],
  });
}
